module.exports = __webpack_public_path__ + "static/media/cert_4996.5e54dddc.jpg";